import { ABSENCE_TYPE_LABELS, AbsenceType, PlayerAbsenceSummary } from '../types/player';

/** Dátum a <input type="date"> mezőhöz, helyi naptár szerint (a toISOString UTC-re váltana). */
export const toDateInputValue = (value: Date | string): string => {
  const date = typeof value === 'string' ? new Date(value) : value;
  if (isNaN(date.getTime())) return '';
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

const shortDate = (value: string) =>
  new Date(value).toLocaleDateString('hu-HU', { month: 'short', day: 'numeric' });

/** Pl. "Beteg · okt. 5. – okt. 12." */
export const describeAbsence = (absence: PlayerAbsenceSummary): string => {
  const label = ABSENCE_TYPE_LABELS[absence.type as AbsenceType] ?? 'Távol';
  const period =
    toDateInputValue(absence.startDate) === toDateInputValue(absence.endDate)
      ? shortDate(absence.startDate)
      : `${shortDate(absence.startDate)} – ${shortDate(absence.endDate)}`;
  return `${label} · ${period}`;
};

/** A jelvény színe a hiányzás típusa szerint. */
export const absenceBadgeClass = (type: AbsenceType): string =>
  type === AbsenceType.Injury
    ? 'bg-orange-100 text-orange-800'
    : type === AbsenceType.Illness
      ? 'bg-rose-100 text-rose-800'
      : 'bg-gray-100 text-gray-700';
